import styled from 'styled-components'
import { dehydrate } from 'react-query/hydration'
import { QueryClient } from 'react-query'
import Navigation from 'components/navigation'
import Footer from 'common/footer'
import OpenGraph from 'common/open-graph'
import ProjectList from 'projects/project-list'
import ProjectsBanner from 'projects/all/banner'
import ProjectsPricing from 'projects/projects-pricing'

import { prefetchSubscriptionPlans } from 'querys/subscriptions'
import { prefetchProjects } from 'querys/projects'

const ProjectsStyled = styled.div`
  .hero-img {
    max-width: 100%;
  }
`

function AllProjects() {

  return (
    <ProjectsStyled>
      <OpenGraph
        title="Todos los proyectos"
        url="https://leonidasesteban.com/proyectos/todos"
        keyword="Retos para Frontend, Crea tu portafolio, Proyectos de Desarrolo Web, Portafolio de proyectos, Creación de Portafolio, Mas Proyectos Menos Diplomas"
        description="Mas proyectos, menos diplomas. Practica tus habilidades de desarrollo web para convertirte en un excelente frontend"
        image="/images/projects/project-open-graph.jpg"
      />
      <Navigation />
      <ProjectsBanner />
      <ProjectList />
      <ProjectsPricing formName="challenge-landing" />
      <Footer />
    </ProjectsStyled>
  )
}

AllProjects.pageTheme = {
  background: 'var(--projects-color)',
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchProjects(queryClient)
  await prefetchSubscriptionPlans({ queryClient, product: 'PROJECTS' })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 3600,
  }
}

export default AllProjects
